var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"sign-in",staticStyle:{"border-color":"#4565D4 !important"},attrs:{"color":"primary"},on:{"click":_vm.openDialog}},[_vm._v(" Sign In ")])
}
var staticRenderFns = []

export { render, staticRenderFns }